import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Cliente } from '../../../../models/importacao-cliente/detalhe-importacao-cliente.model';
import { LoadingService } from '../../../../util/loader.service';
import { ImportarClienteService } from '../importar-cliente.service';
const swal = require('sweetalert');
import * as moment from 'moment';

@Component({
  selector: 'app-modal-editar-cliente-importacao',
  templateUrl: './modal-editar-cliente-importacao.component.html',
  styleUrls: ['./modal-editar-cliente-importacao.component.scss']
})
export class ModalEditarClienteImportacaoComponent implements OnInit {
  public onClose: Subject<any>;
  valForm: FormGroup;
  cliente: Cliente;
  gender = [{ value: 0, description: "Masculino" }, { value: 1, description: "Feminino" }, { description: "Não definido", value: null }];
  constructor(
    private _bsModalRef: BsModalRef,
    public loader: LoadingService,
    private route: ActivatedRoute,
    fb: FormBuilder,
    public service: ImportarClienteService,
    private _localeService: BsLocaleService,
  ) {
    this.valForm = fb.group({
      'nome': [null, [Validators.required]],
      'email': [null, [Validators.nullValidator]],
      'celular': [null, [Validators.required]],
      'dataNascimento': [null, [Validators.nullValidator]],
      'sexo': [null, [Validators.nullValidator]],
    });
    this.cliente = new Cliente();
    this._localeService.use('pt');
  }

  ngOnInit() {
    this.onClose = new Subject();
    if (this.cliente.data_nascimento != null) {
      this.cliente.data_nascimento = moment(new Date(this.cliente.data_nascimento)).format("DD/MM/YYYY")
    }


  }
  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loader.show('body')
      if (this.cliente.data_nascimento != null) {
        this.cliente.data_nascimento = moment(this.cliente.data_nascimento).isValid() ? this.cliente.data_nascimento : this.formatDateBr(this.cliente.data_nascimento);
      }
      this.service.atualizar(this.cliente).subscribe(itens => {
        this.loader.hide('body');
        if (itens === true) {
          swal('Sucesso', 'Informações salvas com sucesso.', 'success');
          this.onOk();
        }

      });
    }
  }
  public onCancel(): void {
    const output = {
      reload: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

  public onOk(): void {
    const output = {
      reload: true
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }
  formatDateBr(dateString): string {
    var dataSplit = dateString.split('/');
    var dateConverted;

    if (dataSplit[2].split(" ").length > 1) {

      var hora = dataSplit[2].split(" ")[1].split(':');
      dataSplit[2] = dataSplit[2].split(" ")[0];
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0], hora[0], hora[1]);

    } else {
      dateConverted = new Date(dataSplit[2], dataSplit[1] - 1, dataSplit[0]);
    }

    return dateConverted;
  }
}
